import { render, staticRenderFns } from "./CorrectiveActions.vue?vue&type=template&id=8ea76d38&scoped=true&"
import script from "./CorrectiveActions.vue?vue&type=script&lang=js&"
export * from "./CorrectiveActions.vue?vue&type=script&lang=js&"
import style0 from "./CorrectiveActions.vue?vue&type=style&index=0&id=8ea76d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea76d38",
  null
  
)

export default component.exports